<history-list title="User history" emptyLabel="No history found." [history]="history()" />
